import { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { LocalizedText } from '@mews/framework';
import { TextKey, ActionType } from '@mews-commander/enums';
import { Dialog, DropDownButton, IconName } from '@optimus-web/core';
import { mapIndexed } from '@mews-commander/utils';
import { navigateInModal as navigateInModalAction } from '../../app/actions/common';
import menuItemHandler from './menuItemHandler';

interface Props {
    actions?: $TSFixMe[];
}

type State = $TSFixMe;

class ContextActionMenu extends Component<Props, State> {
    state = {
        openedDialogIndex: null,
        isDialogFetching: false,
    };

    createDialogOpenHandler = (index: $TSFixMe) => () => this.setState({ openedDialogIndex: index });

    handleCloseDialog = () => {
        if (!this.state.isDialogFetching) {
            this.setState({ openedDialogIndex: null });
        }
    };

    createConfirmationHandler = (url: $TSFixMe) => () => {
        this.setState({ isDialogFetching: true });
        // @ts-expect-error $TSFixMeError: Property 'navigateInModal' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { navigateInModal } = this.props;

        navigateInModal(url);
    };

    mapMenuItems = mapIndexed((action: $TSFixMe, index: $TSFixMe) =>
        menuItemHandler(action.type, { action, handleOpenDialog: this.createDialogOpenHandler(index) })
    );

    render() {
        const { actions } = this.props;
        if (isEmpty(actions)) {
            return null;
        }

        const { openedDialogIndex, isDialogFetching } = this.state;

        return (
            <Fragment>
                <DropDownButton icon={IconName.More} size="small" variant="ghost">
                    {this.mapMenuItems(actions)}
                </DropDownButton>
                {mapIndexed(({ type, ...other }: $TSFixMe, index: $TSFixMe) => {
                    if (type === ActionType.ConfirmationDialog) {
                        const { buttonText, dialogPrimaryButtonText, title, text, isDanger, url, onConfirmation, key } =
                            other;
                        return (
                            <Dialog
                                key={key ?? index}
                                title={title}
                                active={index === openedDialogIndex}
                                onClose={title ? this.handleCloseDialog : undefined}
                                actions={[
                                    {
                                        children: <LocalizedText textKey={TextKey.GoBack} />,
                                        onClick: this.handleCloseDialog,
                                        variant: 'ghost',
                                        type: 'button',
                                    },
                                    {
                                        children: dialogPrimaryButtonText || buttonText,
                                        onClick: onConfirmation || this.createConfirmationHandler(url),
                                        variant: isDanger ? 'destructive' : 'primary',
                                        type: 'submit',
                                    },
                                ]}
                                loading={isDialogFetching}
                            >
                                {text}
                            </Dialog>
                        );
                    }
                    return null;
                }, actions)}
            </Fragment>
        );
    }
}

export default connect(undefined, {
    navigateInModal: navigateInModalAction,
})(ContextActionMenu);
